import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import StyledTextField from '../common/StyledTextField';
import { postRequest } from '../../requestUtils';
import copyTextToClipboard from '../../clipboardUtils';
import confirmationSentImg from '../../../assets/images/confirmation_sent.png';
import { analyticsTrack } from '../../analyticsUtils';
import './ConsultantCard.scss';
var renderTitleAndDepartment = function renderTitleAndDepartment(title, department, mediumWeightClass) {
  return /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 ".concat(mediumWeightClass && 'medium-weight')
  }, title, /*#__PURE__*/React.createElement("span", {
    className: "normal-weight"
  }, department && " - ".concat(department)));
};
var renderSkills = function renderSkills(name, skills, highlightValue) {
  if (skills && skills.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "skill"
    }, /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 medium-weight skill-name"
    }, name), skills.map(function (skill) {
      return /*#__PURE__*/React.createElement("span", {
        key: skill,
        className: "badge small ".concat(skill === highlightValue ? 'purple-base' : 'blue-light')
      }, skill);
    }));
  }
  return null;
};
var ConsultantCard = /*#__PURE__*/function (_Component) {
  function ConsultantCard(props) {
    var _this;
    _classCallCheck(this, ConsultantCard);
    _this = _callSuper(this, ConsultantCard, [props]);
    _this.state = {
      showModal: props.showModal || false,
      showInfoSent: false,
      connected: false,
      proposalRequested: props.proposalRequested || false,
      email: props.email || '',
      validForm: false,
      copied: false,
      copyFailed: false
    };
    _this.copyResetTimer = null;
    _this.open = _this.open.bind(_this);
    _this.close = _this.close.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.connect = _this.connect.bind(_this);
    _this.requestProposal = _this.requestProposal.bind(_this);
    _this.openForm = _this.openForm.bind(_this);
    _this.onCopy = _this.onCopy.bind(_this);
    return _this;
  }
  _inherits(ConsultantCard, _Component);
  return _createClass(ConsultantCard, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.copyResetTimer);
    }
  }, {
    key: "onCopy",
    value: function () {
      var _onCopy = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        var shareLink, success;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              shareLink = this.props.shareLink;
              _context.next = 3;
              return copyTextToClipboard(shareLink);
            case 3:
              success = _context.sent;
              this.setState({
                copied: success,
                copyFailed: !success
              });
              clearTimeout(this.copyResetTimer);
              this.copyResetTimer = setTimeout(function () {
                _this2.setState({
                  copied: false,
                  copyFailed: false
                });
              }, success ? 1500 : 3000);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function onCopy() {
        return _onCopy.apply(this, arguments);
      }
      return onCopy;
    }()
  }, {
    key: "open",
    value: function open() {
      var _this$props = this.props,
        featuredProfile = _this$props.featuredProfile,
        location = _this$props.location;
      analyticsTrack('Clicked on View Profile', {
        location: location,
        resource_id: featuredProfile.resource_id
      });
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        showModal: false,
        showInfoSent: false
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      this.setState(_defineProperty({
        validForm: target.validity.valid
      }, target.name, target.value));
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this3 = this;
      var _this$props2 = this.props,
        connectUrl = _this$props2.connectUrl,
        csrfToken = _this$props2.csrfToken,
        featuredProfile = _this$props2.featuredProfile;
      var _this$state = this.state,
        name = _this$state.name,
        email = _this$state.email,
        company = _this$state.company,
        validForm = _this$state.validForm;
      if (this.props.email || validForm) {
        postRequest(connectUrl, {
          employer: {
            name: name,
            email: email,
            company_name: company
          }
        }, csrfToken).then(function () {
          _this3.setState({
            connected: true
          });
          analyticsTrack('Clicked on Get Connected', {
            location: 'Featured Consultants',
            resource_id: featuredProfile.resource_id
          });
        });
      }
    }
  }, {
    key: "requestProposal",
    value: function requestProposal() {
      var _this4 = this;
      var _this$props3 = this.props,
        requestProposalUrl = _this$props3.requestProposalUrl,
        csrfToken = _this$props3.csrfToken,
        featuredProfile = _this$props3.featuredProfile;
      postRequest(requestProposalUrl, {
        consultant_profile_id: featuredProfile.id
      }, csrfToken).then(function () {
        _this4.setState({
          proposalRequested: true,
          showInfoSent: true
        });
        analyticsTrack('Clicked on Request Proposal', {
          location: 'Project Show',
          resource_id: featuredProfile.resource_id
        });
      });
    }
  }, {
    key: "openForm",
    value: function openForm() {
      this.typeformEmbed.typeform.open();
    }
  }, {
    key: "renderForm",
    value: function renderForm(featuredProfile) {
      var email = this.props.email;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-8"
      }, "Get connected with", featuredProfile.name), /*#__PURE__*/React.createElement("p", null, "Fill out the form below and Clora will be in touch with you shortly to facilitate an introduction with", ' ', featuredProfile.name)), /*#__PURE__*/React.createElement("form", {
        id: "connect-with-featured-profile",
        onSubmit: function onSubmit(event) {
          return event.preventDefault();
        }
      }, /*#__PURE__*/React.createElement(StyledTextField, {
        className: "form-control fs-hide validate",
        name: "email",
        label: "Work Email",
        type: "email",
        margin: "normal",
        defaultValue: email,
        onChange: this.handleInputChange,
        required: true,
        autoFocus: true
      }), /*#__PURE__*/React.createElement("div", {
        className: "actions mt-3"
      }, /*#__PURE__*/React.createElement("input", {
        type: "submit",
        name: "commit",
        id: "get-connected",
        className: "btn btn-primary",
        value: "Get Connected",
        onClick: this.connect
      }))));
    }
  }, {
    key: "renderOverview",
    value: function renderOverview() {
      var _this5 = this;
      var includeLinkButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var shortened = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var featuredProfile = this.props.featuredProfile;
      var _this$state2 = this.state,
        copied = _this$state2.copied,
        copyFailed = _this$state2.copyFailed,
        proposalRequested = _this$state2.proposalRequested,
        showModal = _this$state2.showModal;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, includeLinkButton && /*#__PURE__*/React.createElement("div", {
        className: "pull-right"
      }, copied && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-check"
      }), copyFailed && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle copy-link-failed"
      }), !copied && !copyFailed && /*#__PURE__*/React.createElement("a", {
        className: "btn-secondary",
        role: "button",
        tabIndex: 0,
        "aria-label": "Copy link",
        onClick: this.onCopy,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this5.onCopy();
          }
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-link copy-link"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: !shortened && 'g-flex-8'
      }, proposalRequested && !showModal && shortened && /*#__PURE__*/React.createElement("div", {
        className: "body-text-3 regular demibold green-label mb-8"
      }, "Proposal Requested"), shortened && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 bold d-inline-block mr-8 mb-4 transform-name"
      }, featuredProfile.name), !shortened && /*#__PURE__*/React.createElement("h2", {
        className: "d-inline-block mr-8 mb-4 transform-name"
      }, featuredProfile.name), featuredProfile.years_of_experience && /*#__PURE__*/React.createElement("span", {
        className: "body-text-2 medium-weight"
      }, "|", ' ', featuredProfile.years_of_experience, ' ', "years of experience")), /*#__PURE__*/React.createElement("div", {
        className: !shortened && 'g-flex-4'
      }, proposalRequested && showModal && !shortened && /*#__PURE__*/React.createElement("div", {
        className: "body-text-3 regular demibold green-label mb-8"
      }, "Proposal Requested"))), featuredProfile.city && /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 muted-gray-text"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-map-marker-alt me-3"
      }), /*#__PURE__*/React.createElement("span", {
        className: "d-inline-block"
      }, featuredProfile.city))), /*#__PURE__*/React.createElement("div", {
        className: "experiences"
      }, featuredProfile.recent_titles && /*#__PURE__*/React.createElement("div", {
        className: "recent-titles mb-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight mb-4 green"
      }, "Recent Titles"), featuredProfile.recent_titles[0] && renderTitleAndDepartment(featuredProfile.recent_titles[0].title, featuredProfile.recent_titles[0].department, !shortened), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight"
      }, featuredProfile.recent_titles[1] && renderTitleAndDepartment(featuredProfile.recent_titles[1].title, featuredProfile.recent_titles[1].department, !shortened))), !shortened && featuredProfile.previous_companies && /*#__PURE__*/React.createElement("div", {
        className: "recent-companies"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight mb-4 green"
      }, "Previous Companies"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, featuredProfile.previous_companies[0]), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, featuredProfile.previous_companies[1]))));
    }
  }, {
    key: "renderInfoSent",
    value: function renderInfoSent() {
      var _this6 = this;
      var _this$props4 = this.props,
        featuredProfile = _this$props4.featuredProfile,
        email = _this$props4.email;
      var _this$state3 = this.state,
        connected = _this$state3.connected,
        proposalRequested = _this$state3.proposalRequested;
      return /*#__PURE__*/React.createElement("div", {
        className: "information-sent"
      }, /*#__PURE__*/React.createElement("img", {
        src: confirmationSentImg,
        className: "confirmation-sent",
        alt: "confirmation sent"
      }), connected && /*#__PURE__*/React.createElement("h2", {
        className: "mb-4"
      }, email ? 'Clora will reach out to you shortly!' : 'Your information was sent!'), proposalRequested && /*#__PURE__*/React.createElement("h2", {
        className: "mb-4"
      }, "You requested a proposal from", ' ', featuredProfile.name), connected && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        className: "body-text-2"
      }, email ? "Clora will be in touch with you shortly to facilitate an introduction with ".concat(featuredProfile.name) : 'Clora will reach out to you shortly.'), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary leave-feedback",
        onClick: function onClick() {
          return _this6.openForm();
        }
      }, "Leave Feedback")), proposalRequested && /*#__PURE__*/React.createElement("p", {
        className: "body-text-2"
      }, "Clora will contact", ' ', featuredProfile.name, "and invite them to fill out a proposal for your project."));
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var _this$props5 = this.props,
        featuredProfile = _this$props5.featuredProfile,
        email = _this$props5.email,
        isRep = _this$props5.isRep,
        filters = _this$props5.filters,
        location = _this$props5.location;
      var _this$state4 = this.state,
        connected = _this$state4.connected,
        showInfoSent = _this$state4.showInfoSent,
        proposalRequested = _this$state4.proposalRequested;
      var onProjectShow = location === 'Project Show';
      if (email) {
        if (connected || showInfoSent) {
          return [/*#__PURE__*/React.createElement(Modal.Header, {
            closeButton: true
          }), /*#__PURE__*/React.createElement(Modal.Body, null, this.renderInfoSent())];
        }
        return [/*#__PURE__*/React.createElement(Modal.Header, {
          closeButton: true
        }), /*#__PURE__*/React.createElement(Modal.Body, {
          className: "consultant-details-modal-body"
        }, /*#__PURE__*/React.createElement("div", {
          className: "consultant-details white-background"
        }, this.renderOverview(isRep, false), /*#__PURE__*/React.createElement("div", {
          className: "tags"
        }, renderSkills('Functional Areas', featuredProfile.area_of_expertises, filters.aoe), renderSkills('Therapeutic Areas', featuredProfile.therapeutic_areas, filters.ta), renderSkills('Treatment Modalities', featuredProfile.therapies, filters.pt)), /*#__PURE__*/React.createElement("div", {
          className: "action mt-4 text-center"
        }, onProjectShow && !proposalRequested && /*#__PURE__*/React.createElement("button", {
          id: "",
          className: "btn btn-primary",
          onClick: this.requestProposal
        }, "Request Proposal"), !onProjectShow && /*#__PURE__*/React.createElement("button", {
          id: "get-connected",
          className: "btn btn-primary",
          onClick: this.connect
        }, "Get Connected"))))];
      }
      return /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-7 consultant-details"
      }, this.renderOverview(false, false), /*#__PURE__*/React.createElement("div", {
        className: "tags"
      }, renderSkills('Functional Areas', featuredProfile.area_of_expertises, filters.aoe), renderSkills('Therapeutic Areas', featuredProfile.therapeutic_areas, filters.ta), renderSkills('Treatment Modalities', featuredProfile.therapies, filters.pt))), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-5 interest-form"
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this.close,
        role: "button",
        tabIndex: 0,
        className: "close-modal"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-times fa-lg"
      })), connected ? this.renderInfoSent() : this.renderForm(featuredProfile))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;
      var _this$props6 = this.props,
        location = _this$props6.location,
        featuredProfile = _this$props6.featuredProfile,
        email = _this$props6.email,
        filters = _this$props6.filters,
        isRep = _this$props6.isRep,
        truncated = _this$props6.truncated;
      var onProjectShow = location === 'Project Show';
      return [/*#__PURE__*/React.createElement("div", {
        className: "consultant-card",
        onMouseOver: this.handleMouseOver,
        onFocus: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave,
        onClick: this.open,
        role: "button",
        tabIndex: 0
      }, !onProjectShow && /*#__PURE__*/React.createElement(ReactTypeformEmbed, {
        popup: true,
        autoOpen: false,
        mode: "drawer_right",
        url: "https://clora.typeform.com/to/H7h7zx",
        ref: function ref(tf) {
          _this7.typeformEmbed = tf;
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "consultant-info"
      }, this.renderOverview(isRep, truncated), !truncated && /*#__PURE__*/React.createElement("div", {
        className: "tags"
      }, renderSkills('', featuredProfile.area_of_expertises.slice(0, 3), filters.aoe))), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("button", {
        className: onProjectShow ? 'btn btn-secondary' : 'btn btn-primary',
        onClick: this.open
      }, onProjectShow ? 'View more' : 'View Profile'))), /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.close,
        dialogClassName: "style-guide ".concat(email && 'modal-600w')
      }, this.renderModal())];
    }
  }]);
}(Component);
ConsultantCard.propTypes = {
  location: PropTypes.string.isRequired,
  featuredProfile: PropTypes.shape({}).isRequired,
  connectUrl: PropTypes.string.isRequired,
  requestProposalUrl: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  shareLink: PropTypes.string.isRequired,
  showModal: PropTypes.bool,
  proposalRequested: PropTypes.bool,
  isRep: PropTypes.bool,
  filters: PropTypes.shape({}),
  truncated: PropTypes.bool
};
ConsultantCard.defaultProps = {
  showModal: false,
  proposalRequested: false,
  filters: {},
  truncated: false
};
export default ConsultantCard;